module.exports = __webpack_public_path__ + "static/favicon-eade9078cb80d926573e775db1e41c03.ico";